export default "__VITE_ASSET__CbIx0jfC__"